import { LMLookupDialogComponent } from './lm-lookup-dialog.component';

export class LMLookupSelectionEvent {
  constructor(public eventSource: LMLookupDialogComponent,
    public rows: Array<any>) {
  }
}
